// extracted by mini-css-extract-plugin
module.exports = {"marginTopZero":"_2KvQNPV0sKXhaib-rmvvie","editBtn":"_11eaNylblF2aEdOOiBI9cT","icon":"_1gdIj8FKCMcm-RvxotGtGd"};